package co.maytes.standupbot.dashboard.features.ds

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.components.motion.pressable
import co.maytes.standupbot.dashboard.components.widgets.Badge
import co.maytes.standupbot.dashboard.components.widgets.BadgeTone
import co.maytes.standupbot.dashboard.components.widgets.Card
import co.maytes.standupbot.dashboard.components.widgets.Chip
import co.maytes.standupbot.dashboard.components.widgets.ChipTone
import co.maytes.standupbot.dashboard.components.widgets.cssRgb
import co.maytes.standupbot.dashboard.styles.Palette
import co.maytes.standupbot.dashboard.styles.Typography
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.tabIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText

private val surfaceStates = listOf(GalleryState.Rest, GalleryState.Hover, GalleryState.Focus, GalleryState.Active)
private val restOnly = listOf(GalleryState.Rest)

@Composable
fun ComponentsSection() {
    GallerySection(
        id = "components",
        title = "Components (current)",
        description = "Display components as they exist today. Forced states copy the registered :hover, " +
            ":focus-visible and :active rules onto [data-force-state]. Components that style hover inline (Chip) " +
            "cannot be forced and show their rest state in every column. GalleryMatrix(component, variants, sizes, " +
            "states) is the helper later PRs use to add rows.",
    ) {
        BadgeMatrix()
        ChipMatrix()
        CardMatrix()
    }
}

@Composable
private fun BadgeMatrix() = GalleryMatrix(
    component = "Badge",
    variants = BadgeTone.entries.map { it.name },
    sizes = listOf("Plain", "Dot"),
    states = restOnly,
) { variant, size, _ ->
    Badge(
        label = variant,
        tone = BadgeTone.valueOf(variant),
        leadingDot = if (size == "Dot") Palette.textSecondary else null,
    )
}

@Composable
private fun ChipMatrix() = GalleryMatrix(
    component = "Chip",
    variants = ChipTone.entries.map { it.name },
    sizes = listOf("Static", "Selected", "Clickable"),
    states = restOnly,
) { variant, size, _ ->
    Chip(
        label = variant,
        tone = ChipTone.valueOf(variant),
        selected = size == "Selected",
        onClick = if (size == "Clickable") ({}) else null,
    )
}

@Composable
private fun CardMatrix() = GalleryMatrix(
    component = "Card",
    variants = listOf("Static", "Interactive"),
    sizes = listOf("Padded", "Flush"),
    states = surfaceStates,
) { variant, size, _ ->
    val interactive = variant == "Interactive"
    Card(
        modifier = (if (interactive) Modifier.tabIndex(0).pressable() else Modifier)
            .styleModifier { property("width", "108px") },
        padded = size == "Padded",
        interactive = interactive,
    ) {
        SpanText(
            text = "$variant card",
            modifier = Modifier.styleModifier {
                property("font-size", "${Typography.caption.size}")
                property("padding", if (size == "Padded") "0" else "8px")
                property("color", Palette.textSecondary.cssRgb())
            },
        )
    }
}

